export function indicatorIds(data, selection) {
    if (!data || !selection) return null;
    if (selection.key === 'open') return data.open.currencies.find(currency => String(currency.id) === String(selection.currencyId))?.ids || [];
    if (selection.key === 'closed') return data.closed.ids;
    if (selection.key === 'overdue') return data.attention.overdue_ids;
    if (selection.key === 'no_next') return data.attention.no_next_ids;
    return data.attention.ids;
}

export function filterIndicatorBoard(stages, ids) {
    if (!ids) return stages;
    const allowed = new Set(ids.map(String));
    return stages.map(stage => {
        const leads = stage.leads.filter(lead => allowed.has(String(lead.id)));
        return { ...stage, leads, cant_deals: leads.length, suma_ingreso: leads.reduce((sum, lead) => sum + (Number(lead.total) || 0), 0) };
    });
}

export function indicatorDropIndex(stages, visibleStages, leadId, destinationId, index) {
    const all = stages.find(stage => String(stage.id) === String(destinationId))?.leads.filter(lead => String(lead.id) !== String(leadId)) || [];
    const visible = visibleStages.find(stage => String(stage.id) === String(destinationId))?.leads.filter(lead => String(lead.id) !== String(leadId)) || [];
    const before = visible[index];
    if (before) return all.findIndex(lead => String(lead.id) === String(before.id));
    const after = visible[index - 1];
    return after ? all.findIndex(lead => String(lead.id) === String(after.id)) + 1 : all.length;
}
